export const BROADCAST_FORM = 'BROADCAST_FORM';
export const CARD_FORM = 'CARD_FORM';
export const PLAN_UPDATE_SUCCESS = 'PLAN_UPDATE_SUCCESS';
export const OUT_OF_SUBSCRIPTION = 'OUT_OF_SUBSCRIPTION';
export const EVENT_DELETE_FORM = 'EVENT_DELETE_FORM';
export const PRE_TRIAL_TEAM_MODAL = 'PRE_TRIAL_TEAM_MODAL';
export const INVITE_CREW_MODAL = 'INVITE_CREW_MODAL';
export const EVENT_INVITE_CREW = 'EVENT_INVITE_CREW';
export const CREATE_TEAM = 'CREATE_TEAM';
export const RESEND_VERIFIY_EMAIL = 'RESEND_VERIFIY_EMAIL';
